import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@shop-ledger/ui-components/styles.css";
import "./index.css";
import { App } from "./App";
import { mockPlatformApiClient } from "./api/mockPlatformApiClient";
import { realPlatformApiClient } from "./api/realPlatformApiClient";
import { PLATFORM_API_MODE } from "./env";

// The backend platform-operator realm (§9.1) is now real — `realPlatformApiClient` is the
// default. Set `VITE_PLATFORM_API_MODE=mock` (see `env.ts`) to opt back into the in-memory
// fixture client for local UI development with no backend running at all, or to keep
// exercising `mockPlatformApiClient.test.ts`'s 26 contract tests' subject unchanged. No page
// component or domain-logic file needs to change either way — both implement the exact same
// `PlatformApiClient` interface.
const client = PLATFORM_API_MODE === "mock" ? mockPlatformApiClient : realPlatformApiClient;

// `index.html`'s static <title> makes no claim about mock vs. real — set it here instead,
// the one place that already knows which client is active, rather than hardcoding "(Demo
// Mode)" into every build regardless of `PLATFORM_API_MODE`.
if (PLATFORM_API_MODE === "mock") {
  document.title = "ZEL-MART — Platform Admin (Mock Mode)";
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("#root element not found");

createRoot(rootElement).render(
  <StrictMode>
    <App client={client} />
  </StrictMode>,
);
